import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Delete } from '@mui/icons-material';
import { IconButton } from '@mui/material';

import { DragHandle } from './DragHandle';
import { SectionItemPresentation } from './SectionItemPresentation';
import type { TemplateSectionItemProps } from './types';

export const TemplateSectionItem: React.FC<TemplateSectionItemProps> = ({ section, onRemove }) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: section.id,
    animateLayoutChanges: () => false, // Disable layout animations for better performance
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    // Only use transition when not dragging to prevent jump on drop
    transition: isDragging ? undefined : transition,
    opacity: isDragging ? 0.5 : 1,
  };

  return (
    <SectionItemPresentation
      section={section}
      paperRef={setNodeRef}
      style={style}
      elevation={1}
      sx={{
        transition: 'border-color 0.2s',
        '&:hover': {
          boxShadow: 2,
          borderColor: 'action.selected',
        },
      }}
      dragHandleSlot={<DragHandle listeners={listeners} attributes={attributes} />}
      actionsSlot={
        <IconButton onClick={() => onRemove(section.id)} color="error" aria-label="Remove section">
          <Delete />
        </IconButton>
      }
    />
  );
};
